import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment/moment';

@Component({
  selector: 'app-week-list-toggle',
  templateUrl: './week-list-toggle.component.html',
  styleUrls: ['./week-list-toggle.component.css']
})
export class WeekListToggleComponent {
  @Output() selectedDayEmitter: EventEmitter<any> = new EventEmitter();
  @Input() selectedDate: string;
  @Input() weekList: any = []
  @Input() loading: boolean = false;

  toggle(week) {
    if (moment(week.date).diff(moment(), 'hours') > 0) {
      return;
    }
    this.selectedDate = week.date;
    this.selectedDayEmitter.emit(week);
  }

  isFuture(week) {
    return moment(week.date).diff(moment(), 'hours') > 0;
  }
}
